var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"w_mail_btn"},[_c('router-link',{attrs:{"to":{
      name: 'boardwrite',
      query:{data:JSON.stringify(_vm.params) }
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }